import type {
    OnboardingTypeSelectionPagePropertyOnboardingContextFieldsV1,
    OnboardingTypeSelectionPagePropertyOnboardingContextIdsV1,
} from "@agoda/analytics-messages-definition-property-onboarding/contexts.split";
import {
    CreateListingManuallyCardElementPropertyOnboardingManifestV1,
    ExitButtonElementPropertyOnboardingManifestV1,
    ImportFromAirbnbCardElementPropertyOnboardingManifestV1,
    ImportFromAnotherPlatformLinkElementPropertyOnboardingManifestV1,
    ImportFromAnotherPlatformNextButtonElementPropertyOnboardingManifestV1,
    ImportFromRakutenCardElementPropertyOnboardingManifestV1,
    NextElementPropertyOnboardingManifestV1,
    SelectLanguageElementPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/elements";
import {
    OnboardingTypeSelectionPagePropertyOnboardingContextManifestV1,
    WebOnboardingTypeSelectionVisitEventPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/onboarding-type-selection-page";
import { BaseContextFieldsMapping } from "../../functions/appContext";
import { defineBinder } from "../../functions/defineBinder";

export const getStartedBinder = defineBinder(({ webAnalytics, action: { click, reveal } }) => {
    webAnalytics.pageContext<
        OnboardingTypeSelectionPagePropertyOnboardingContextIdsV1,
        OnboardingTypeSelectionPagePropertyOnboardingContextFieldsV1
    >(OnboardingTypeSelectionPagePropertyOnboardingContextManifestV1.ids, {
        auth_user_id: BaseContextFieldsMapping.auth_user_id,
        member_id: BaseContextFieldsMapping.member_id,
        property_id: BaseContextFieldsMapping.property_id,
        is_internal_user: BaseContextFieldsMapping.is_internal_user,
    });

    webAnalytics.observe(WebOnboardingTypeSelectionVisitEventPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], SelectLanguageElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], ImportFromAirbnbCardElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], ImportFromRakutenCardElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], CreateListingManuallyCardElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ImportFromAnotherPlatformLinkElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement(
        [click],
        ImportFromAnotherPlatformNextButtonElementPropertyOnboardingManifestV1.ids,
        {},
    );
    webAnalytics.observeElement([click], ExitButtonElementPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], NextElementPropertyOnboardingManifestV1.ids, {});
});
